import React, { createContext, useContext } from "react";
import classnames from "classnames";

export type Level = 1 | 2 | 3 | 4 | 5 | 6;
type HeadingElement = `h{Level}`;

const HeadingContext = createContext<Level>(1);

export type Props = {
  className?: string;
  children: React.ReactNode;
  component?: React.ElementType;
  level?: Level;
} & React.HTMLAttributes<HTMLHeadingElement>;

const Heading = ({ className, children, component, level, ...rest }: Props) => {
  const contextLevel = useContext(HeadingContext);
  // @ts-expect-error TS doesn't know this is a heading element type
  const headingLevel = `h${contextLevel}` as React.ElementType<HeadingElement>;
  const MarkupComponent: React.ElementType | HeadingElement =
    component || headingLevel;

  const classname = `h${level || contextLevel}`;

  return (
    <MarkupComponent className={classnames(className, classname)} {...rest}>
      {children}
    </MarkupComponent>
  );
};

type ContentProps = {
  children: React.ReactNode;
  className?: string;
};

const Content = ({ children, className }: ContentProps) => {
  const contextLevel = useContext(HeadingContext);

  return (
    <HeadingContext.Provider value={(contextLevel + 1) as Level}>
      <div className={className}>{children}</div>
    </HeadingContext.Provider>
  );
};

Heading.Content = Content;

export default Heading;
